import { env } from '@/env';
import axios from '@/utils/api/axios-instance';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';
import type { CategoryRes, ReviewRes, ReviewReq } from '@/models/interface/review';
import type { ReviewRecordReq, ReviewRecordRes } from '@/models/interface/reviewRecord';

export class ReviewService extends ApiFactory {
  constructor() {
    super('MemberRecord');
  }

  fetchData(params: ReviewReq): Promise<ApiDataResponse<ReviewRes>> {
    return this.post('ReviewList', params);
  }

  fetchCategories(): Promise<ApiDataResponse<CategoryRes[]>> {
    return this.get('ReviewCategories');
  }

  upsertReviewRecord(data: ReviewRecordReq): Promise<ApiDataResponse<ReviewRecordRes>> {
    const v2BaseUrl = env.apiBaseUrl.replace('/v1', '/v2');
    return axios.post(`${v2BaseUrl}/ReviewRecord`, data);
  }
}
